import React from "react";
import DashboardLayout from "../../layouts/DashboardLayout/DashboardLayout";

const CandidateModule = () => {
  return <DashboardLayout />;
};

export default CandidateModule;
